import React from 'react'
import UserContext from "../userContext";
import { useHistory } from "react-router-dom";
import { FiLogIn } from "react-icons/fi";

export default function Login() {
    const [email, setEmail] = React.useState('')
    const [password, setPassword] = React.useState('')
    const [remember, setRemember] = React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const [error, setError] = React.useState('')

    const userContext = React.useContext(UserContext)
    const history = useHistory();

    const handleSubmit = (e) => {
        e.preventDefault()
        setLoading(true)
        setError('')

        userContext.apiReducer('login', {
            email: email,
            password: password
        }, { remember: remember })
            .then(() => {
                setLoading(false)
                history.push('/')
            })
            .catch((err) => {
                setLoading(false)
                if (err?.includes("401") || err?.includes("500")) {
                    setError('Identifiants incorrects. Veuillez réessayer.')
                } else {
                    setError('Une erreur est survenue. Veuillez réessayer.')
                }
            })
    }

    return (
        <div className="login-page">
            <div className="login-page__background" />

            <div className="login-page__container">
                <div className="login-page__card">
                    <div className="login-page__header">
                        <img 
                            src="https://i.ibb.co/3CgD7G4/new-Colors-Logo-2.webp" 
                            alt="MYPacôme" 
                            className="login-page__logo"
                        />
                        <h1 className="login-page__title">
                            MY<span>Pacôme</span>
                        </h1>
                        <p className="login-page__subtitle">Concierge Manager</p>
                    </div>

                    <form className="login-page__form" onSubmit={handleSubmit}>
                        <div className="login-page__input-group">
                            <label className="login-page__label" htmlFor="email">
                                Adresse email
                            </label>
                            <input
                                type="email"
                                id="email"
                                className="login-page__input"
                                placeholder="votre@email.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                autoComplete="email"
                            />
                        </div>

                        <div className="login-page__input-group">
                            <label className="login-page__label" htmlFor="password">
                                Mot de passe
                            </label>
                            <input
                                type="password"
                                id="password"
                                className="login-page__input"
                                placeholder="••••••••"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                autoComplete="current-password"
                            />
                        </div>

                        <label className="login-page__checkbox">
                            <input
                                type="checkbox"
                                checked={remember}
                                onChange={(e) => setRemember(e.target.checked)}
                            />
                            <span>Se souvenir de moi</span>
                        </label>

                        {error && (
                            <div className="login-page__error">
                                {error}
                            </div>
                        )}

                        <button 
                            type="submit" 
                            className="login-page__submit"
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <span className="spinner-small" />
                                    Connexion...
                                </>
                            ) : (
                                <>
                                    <FiLogIn />
                                    Connexion
                                </>
                            )}
                        </button>

                        <div className="login-page__divider">
                            <span>ou</span>
                        </div>

                        <button
                            type="button"
                            className="login-page__link"
                            onClick={() => history.push('/reset')}
                        >
                            Mot de passe oublié ?
                        </button>
                    </form>

                    <div className="login-page__footer">
                        <p>© {new Date().getFullYear()} MYPacôme. Tous droits réservés.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
